import classNames from 'classnames'

import type { ButtonHTMLAttributes, ReactElement } from 'react'

import columnGraphIcon1 from '~/assets/column-graph-icon-1.svg'
import columnGraphIcon2 from '~/assets/column-graph-icon-2.svg'
import lineGraphIcon from '~/assets/line-graph-icon.svg'
import spLineGraphIcon from '~/assets/spline-graph-icon.svg'
import stackedColumnGraphIcon1 from '~/assets/stacked-column-graph-icon-1.svg'
import stackedColumnGraphIcon2 from '~/assets/stacked-column-graph-icon-2.svg'
import stackedColumnPercentGraphIcon1 from '~/assets/stacked-column-percent-graph-icon-1.svg'
import stackedColumnPercentGraphIcon2 from '~/assets/stacked-column-percent-graph-icon-2.svg'
import Tooltip from '~/components/Tooltip'
import { GRAPH_TYPE } from '~/const/graphs-builder'

import './styles.scss'

interface Props {
  disabled?: boolean
  graphType: GRAPH_TYPE
  selectedGraphType: GRAPH_TYPE
}

const renderGraphIcon = (type: GRAPH_TYPE): ReactElement | undefined => {
  switch (type) {
    case GRAPH_TYPE.LINE:
      return <img src={lineGraphIcon} />
    case GRAPH_TYPE.COLUMN:
      return (
        <>
          <img src={columnGraphIcon1} />
          <img src={columnGraphIcon2} />
        </>
      )
    case GRAPH_TYPE.RAW:
      return <>%</>
    case GRAPH_TYPE.STACKED_COLUMN:
      return (
        <>
          <img src={stackedColumnGraphIcon1} />
          <img src={stackedColumnGraphIcon2} />
        </>
      )
    case GRAPH_TYPE.STACKED_COLUMN_PERCENT:
      return (
        <>
          <img src={stackedColumnPercentGraphIcon1} />
          <img src={stackedColumnPercentGraphIcon2} />
        </>
      )
    case GRAPH_TYPE.SPLINE:
      return <img src={spLineGraphIcon} />
    default:
      return
  }
}

const GraphTypeButton = ({
  disabled,
  graphType,
  onClick,
  selectedGraphType,
}: Props & ButtonHTMLAttributes<HTMLButtonElement>): ReactElement => {
  const graphTypeButtonClasses = classNames('graph-type-button-component', {
    'is-disabled': !!disabled,
    'is-selected': graphType === selectedGraphType,
  })

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (onClick && !disabled) onClick(e)
  }

  return (
    <Tooltip
      mouseEnterDelay={0.5}
      overlay={<div>{graphType.split('_').join(' ')}</div>}
      placement="top"
      trigger="hover"
    >
      <button className={graphTypeButtonClasses} onClick={(e) => handleClick(e)} type="button">
        {renderGraphIcon(graphType)}
      </button>
    </Tooltip>
  )
}

export default GraphTypeButton
